import ModalBase from "../index";
import {DialogContent} from "@material-ui/core";
import React from "react";

const StandaloneModal = ({title, children, dialogContentClasses, ...rest}) => {
    return (
        <ModalBase title={title} handleClose={rest.onClose} {...rest}>
            <DialogContent className={dialogContentClasses}>
                {children}
            </DialogContent>
        </ModalBase>
    );
};

export default StandaloneModal;
